/**
 * Request/response contract for the TagForge smart-tags service.
 */

import { z } from 'zod';

/**
 * Body accepted by both `POST /api/tags` (our proxy) and TagForge `POST /tags`.
 * Only `text` is required; the rest tune matching and fall back to TagForge's
 * own defaults when omitted.
 */
export const SmartTagRequestSchema = z.object({
  text: z.string().min(1),
  simThreshold: z.number().min(0).max(1).optional(),
  maxTagMatches: z.number().int().positive().optional(),
  maxFeaturesPerTag: z.number().int().positive().optional(),
  maxChunksPerFeature: z.number().int().positive().optional(),
  index: z.string().min(1).optional(),
});
export type SmartTagRequest = z.infer<typeof SmartTagRequestSchema>;

export const ChunkMatchSchema = z.object({
  chunkText: z.string(),
  simScore: z.number(),
});
export type ChunkMatch = z.infer<typeof ChunkMatchSchema>;

export const FeatureMatchSchema = z.object({
  featureName: z.string(),
  chunkMatches: z.array(ChunkMatchSchema),
});
export type FeatureMatch = z.infer<typeof FeatureMatchSchema>;

export const TagMatchSchema = z.object({
  tagName: z.string(),
  maxMatchSim: z.number(),
  featureMatches: z.array(FeatureMatchSchema),
});
export type TagMatch = z.infer<typeof TagMatchSchema>;

export const TagResponseSchema = z.object({
  matches: z.array(TagMatchSchema),
});
export type TagResponse = z.infer<typeof TagResponseSchema>;
